var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{style:(_vm.cssProps)},[_c('label',{staticClass:"switch"},[_c('input',{ref:"switch",attrs:{"disabled":_vm.disabled,"type":"checkbox"},domProps:{"value":_vm.value,"checked":_vm.value},on:{"click":_vm.emitValue}}),_c('span',{staticClass:"slider round",style:(_vm.cursor)})])])
}
var staticRenderFns = []

export { render, staticRenderFns }